import { Component, OnInit, inject } from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { CacheControllerService } from "../../../../modules/lipidcompass-backend-client";
import { LoggingService } from "../../_services/logging.service";
import { FormsModule } from "@angular/forms";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { ButtonGroupModule } from "primeng/buttongroup";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ToastModule } from "primeng/toast";

@Component({
  selector: "app-admin-caches",
  templateUrl: "./admin-caches.component.html",
  styleUrls: ["./admin-caches.component.css"],
  standalone: true,
  imports: [
    ButtonModule,
    ButtonGroupModule,
    ConfirmDialogModule,
    FormsModule,
    TableModule,
    ToastModule
  ]
})
export class AdminCachesComponent implements OnInit {
  private controller = inject(CacheControllerService);
  private messageService = inject(MessageService);
  private confirmationService = inject(ConfirmationService);
  private loggingService = inject(LoggingService);

  cacheNames: string[] = [];
  loading: boolean = false;

  ngOnInit() {
    this.reload();
  }

  reload() {
    this.loading = true;
    this.controller.cacheGetCacheNames().subscribe({
      next: names => {
        this.cacheNames = names;
        this.loading = false;
      },
      error: error => {
        this.loggingService.error(
          "AdminCachesComponent",
          "Failed to load cache names"
        );
        this.messageService.add({
          severity: "error",
          summary: "Error",
          detail: "Failed to load cache names"
        });
        this.loading = false;
      }
    });
  }

  deleteCache(cache: string) {
    this.confirmationService.confirm({
      header: "Clear Cache",
      message: "Are you sure you want to clear the cache " + cache + "?",
      accept: () => {
        this.controller.cacheClearCache(cache).subscribe({
          next: () => {
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Cache cleared successfully"
            });
          },
          error: () => {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Failed to clear cache"
            });
          }
        });
      }
    });
  }

  deleteAllCaches() {
    this.confirmationService.confirm({
      header: "Clear All Caches",
      message: "Are you sure you want to clear all caches?",
      accept: () => {
        this.controller.cacheClearCaches().subscribe({
          next: () => {
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Caches cleared successfully"
            });
          },
          error: () => {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Failed to clear caches"
            });
          }
        });
      }
    });
  }

  warmupCaches() {
    this.confirmationService.confirm({
      header: "Warmup All Caches",
      message: "Are you sure you want to warmup all caches?",
      accept: () => {
        this.controller.cacheWarmUpCaches().subscribe({
          next: () => {
            this.messageService.add({
              severity: "success",
              summary: "Success",
              detail: "Cache warmup started successfully!"
            });
          },
          error: () => {
            this.messageService.add({
              severity: "error",
              summary: "Error",
              detail: "Failed to warmup caches"
            });
          }
        });
      }
    });
  }
}
